import React from 'react';
import { StytchB2B } from '@stytch/react/b2b';
import { AuthFlowType, B2BProducts } from '@stytch/vanilla-js/b2b';

const TestLoginPage = () => {
  // This is a known-good, minimal configuration.
  const config = {
    products: [B2BProducts.emailMagicLinks, B2BProducts.sso], // We need to specify which login products to enable
    authFlowType: AuthFlowType.Discovery,
    sessionOptions: {
      session_duration_minutes: 60,
    },
    ssoOptions: {
      login_redirect_url: 'http://localhost:3000/authenticate', // Use your full dev URL
      signup_redirect_url: 'http://localhost:3000/authenticate',
    },
    magicLinksOptions: {
      login_redirect_url: 'http://localhost:3000/authenticate',
      signup_redirect_url: 'http://localhost:3000/authenticate',
    },
  };

  const pageStyle = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    backgroundColor: '#f0f2f5',
  };

  const componentContainerStyle = {
    width: '360px',
    padding: '40px',
    backgroundColor: 'white',
    borderRadius: '8px',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
  };

  return (
    <div style={pageStyle}>
      <div style={componentContainerStyle}>
        <h1>Test Login Page</h1>
        <StytchB2B config={config} />
      </div>
    </div>
  );
};

export default TestLoginPage;